import React from 'react'
import { useHistory } from 'react-router-dom'
import { notification } from 'antd'
import { View } from './View'
import {
  ResetPasswordRequest,
  useResetPassword,
} from '../../../services/api/auth'

type FormData = ResetPasswordRequest
const initialValues: FormData = {
  email: '',
}

export const Container: React.FunctionComponent = () => {
  const history = useHistory()
  const [resetPassword, { error }] = useResetPassword()

  const onSubmit = (form: FormData) => {
    return resetPassword(form).then(() => {
      openNotification()
      history.push('/home')
    })
  }

  const openNotification = () => {
    notification['success']({
      message: 'Вам отправлено письмо с дальнейшими инструкциями',
      duration: 3,
    })
  }

  return (
    <View error={error} initialValues={initialValues} onSubmit={onSubmit} />
  )
}
